module.exports = __webpack_public_path__ + "static/media/vframer_logo.8f5ec509.png";